/* unplugin-vue-components disabled */import script from "./DataView.vue?vue&type=script&setup=true&lang=js"
export * from "./DataView.vue?vue&type=script&setup=true&lang=js"

import "./DataView.vue?vue&type=style&index=0&id=675d48ca&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-675d48ca"]])

export default __exports__